<template>
  <AdminConfirmModal
    v-model="getDeclineExtensionModal"
    :message="$t('Tariffs.sure_want_decline_continue')"
    :confirm-text="$t('Default.accept')"
    @confirm="declineExtension"
  />
</template>
<script>
import { computed, ref } from "@vue/composition-api";
import { GlobalMutationTypes } from "@/store/modules/global/types";
import { DispatchTypes } from "@/store/modules/admin/tariffs/types";
import { shortComputed } from "@/utility/helpers";
import { useStore } from "vuex-composition-helpers";
import { globalVariables } from "@/utility/variables";
import AdminConfirmModal from "@/components/partials/Admin/AdminConfirmModal.vue";

export default {
  components: { AdminConfirmModal },
  props: [],
  setup(props, { root }) {
    const store = useStore();

    const { userInfo } = globalVariables();

    const getDeclineExtensionModal = shortComputed(
      {
        storeType: "global",
        key: "getDeclineExtensionModal",
      },
      GlobalMutationTypes.setDeclineExtensionModal
    );

    const payload = ref({
      status: 3,
    });

    const declineExtension = () => {
      store
        .dispatch(DispatchTypes.changeTariffApplication, {
          id: currentTariffApplication.value.id,
          payload: payload.value,
        })
        .then(() => {
          store.commit(GlobalMutationTypes.setDeclineExtensionModal, false);
          store.dispatch(DispatchTypes.getTariffsApplication, "?status=" + 1);
          root.$router.push("/admin/extension");
        });
    };
    const currentTariffApplication = computed(
      () => store.state.tariffs.tariffApplication
    );

    return {
      store,
      getDeclineExtensionModal,
      declineExtension,
      userInfo,
      payload,
    };
  },
};
</script>
